import { Ng1StateDeclaration } from "@uirouter/angularjs";
import { modal } from "@gtmhub/core/routing";
import { featureToggleEnabledV2 } from "../resolveGuards";
import { FeatureFlag } from "@gtmhub/featureToggle/models";

const commonStyles = {
  styleUrl: require("./whiteboards.less"),
};

export const whiteboardsState: Ng1StateDeclaration = {
  name: "gtmhub.whiteboards",
  url: "/whiteboards/",
  data: {
    titleKey: "whiteboards",
    trackingPage: "Whiteboards",
    ...commonStyles,
  },
  component: "whiteboards",
  resolve: {
    _featureAvailable: featureToggleEnabledV2(FeatureFlag.ModuleWhiteboards),
  },
};

export const whiteboardState: Ng1StateDeclaration = {
  name: "gtmhub.whiteboard",
  url: "/whiteboards/:whiteboardId/",
  params: {
    whiteboardId: null,
  },
  data: {
    trackingPage: "Whiteboard Details",
    ...commonStyles,
  },
  component: "whiteboard",
  resolve: {
    _featureAvailable: featureToggleEnabledV2(FeatureFlag.ModuleWhiteboards),
  },
};

export const draftGoalState = modal({
  name: `${whiteboardState.name}.draftGoal`,
  url: "drafts/goals/:goalId/",
  data: {
    trackingPage: "Drafts Goal Details",
  },
  component: "draftGoal",
  params: {
    goalId: null,
  },
  windowClass: "goal-sidebar",
});

export const draftMetricState = modal({
  name: `${draftGoalState.name}.draftMetric`,
  url: "metrics/:metricId/",
  data: {
    trackingPage: "Metric Details",
  },
  component: "draftMetric",
  params: {
    metricId: null,
  },
  windowClass: "sidebar-modal draft-metric-modal",
});
